export default __webpack_public_path__ + "static/media/whiskeydrinks.a22fb91b.png";